import * as _actions from './actions.js';
import * as _selectors from './selectors.js';
import * as _utils from './utils.js';
import { aiChatReducer } from './reducers.js';
import saga from './saga.js';
import { store, sagaMiddleware } from '../../store.js';

export const actions = _actions;
export const selectors = _selectors;
export const utils = _utils;

store.addReducers({
  'ai-chat': aiChatReducer
});

sagaMiddleware.run(saga);
